<template>
  <div class="table">
    <div class="tr" v-for="(row, idx) in table.rows" :key="idx">
      <div class="td" v-for="(col, idx) in row" :key="idx">
        <div class="td__title">{{col.name}}:</div>
        <div class="td__value">{{col.value}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['item'],
    computed: {
      table() {
        return this.$props.item.original_sales_table;
      },
    },
  };
</script>

<style scoped lang="scss">
  .table {
    .tr {
      border: 1px solid #006ebf;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
    }
    .th {
      &:last-child {
        border-right: 1px solid #006ebf;
      }
    }
    .td {
      border-bottom: 1px solid #006ebf;
      display: flex;
      @media (max-width: 576px) {
        flex-direction: column;
      }
      &__title {
        background-color: #006ebf;
        color: white;
        padding: 5px 8px;

        @media (min-width: 577px) {
          flex: 0 0 190px;
          border-bottom: 1px solid white;
        }
      }

      &__value {
        padding: 5px 8px;
      }

      &:last-child {
        border: none;
        .td__title {

          @media (min-width: 577px) {
            border-bottom: none;
          }
        }
      }
    }
  }


</style>
